import { FixaSkeleton } from "../../../shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./task-card-skeleton.module.css";

export const TaskCardSkeleton = () => {
  return (
    <div className={styles["skeleton-wrapper"]}>
      <FixaSkeleton height="20px" width="100px" />
      <div className={styles["skeleton-middle-wrapper"]}>
        <div className={styles["skeleton-image"]}>
          <FixaSkeleton height="69px" width="69px" />
        </div>
        <div className={styles["skeleton-info-wrapper"]}>
          <FixaSkeleton height="19px" width="150px" />
          <FixaSkeleton height="19px" width="100px" />
          <FixaSkeleton height="19px" width="200px" />
        </div>
      </div>
      <FixaSkeleton height="37px" />
      <div className={styles["skeleton-bottom-wrapper"]}>
        <FixaSkeleton height="21px" width="75px" />
        <FixaSkeleton height="21px" width="150px" />
      </div>
    </div>
  );
};
